module.exports = __webpack_public_path__ + "img/coingecko.6722be3c.webp";